<template>
  <NuxtLoadingIndicator />
  <v-main style="padding-top: 3rem">
    <NuxtPage />
  </v-main>
</template>

<script lang="ts" setup>
  //
</script>
